<template>
  <div class="pay-banner-ad" v-if="slotConfig">
    <ad-yunzong
      v-if="slotConfig.source === 'yunzong'"
      :urls="slotConfig.id"
      @hook:mounted="onNonPcloudMounted"
    />
    <ad-bosite
      v-else-if="slotConfig.source === 'bosite'"
      :urls="slotConfig.id"
      @hook:mounted="onNonPcloudMounted"
    />
    <ad-pcloud
      v-else-if="slotConfig.source === 'pcloud'"
      :spaceId="slotConfig.id"
      @loaded="onLoaded"
      @failed="onFailed"
    />
    <ad-qunfeng
      v-else-if="slotConfig.source === 'qunfeng'"
      :positionId="slotConfig.id"
      @hook:mounted="onNonPcloudMounted"
    />
  </div>
</template>

<script>
import { getBannerSlotConfig } from '../../../config/adConfig'
import AdYunzong from './ad_yunzong.vue'
import AdBosite from './ad_bosite.vue'
import AdPcloud from './ad_pcloud.vue'
import AdQunfeng from './ad_qunfeng.vue'

export default {
  name: 'PayBannerAd',
  components: { AdYunzong, AdBosite, AdPcloud, AdQunfeng },
  props: {
    /** adConfig 中的槽位 key，如 EXIT_ORDER_TOP_BANNER */
    position: {
      type: String,
      required: true
    }
  },
  computed: {
    slotConfig () {
      return getBannerSlotConfig(this.position)
    }
  },
  methods: {
    onLoaded (data) {
      this.$emit('loaded', data)
    },
    onFailed (err) {
      this.$emit('failed', err)
    },
    onNonPcloudMounted () {
      this.$nextTick(() => {
        this.$emit('loaded')
      })
    }
  }
}
</script>

<style scoped>
.pay-banner-ad {
  width: 100%;
}
</style>
